import { Invoice } from 'src/models/payment/_types';
import { Identifier } from 'src/types/utilityTypes';

/**
 * Stripe customer owner for Pay Balance when invoices bill to paid_by (e.g. manager use_card).
 */
export function resolveBillingUserId(
  memberUserId: Identifier,
  payableInvoices: Invoice[]
): Identifier {
  if (payableInvoices.length === 0) {
    return memberUserId;
  }

  const paidByIds = [
    ...new Set(
      payableInvoices
        .map((invoice) => invoice.paidById)
        .filter((id): id is Identifier => id != null && id !== '')
    ),
  ];

  if (paidByIds.length !== 1) {
    return memberUserId;
  }

  return paidByIds[0];
}
